module.exports = " <div id=app> <vuelightbox id=mylightbox :images=images :image_class=\" 'img-responsive img-rounded' \" :album_class=\" 'my-album-class' \" :options=options> </vuelightbox> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 10
// module chunks = 0